import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";
import {Article, Delete, Download} from "@mui/icons-material";

export const InitiativeAttachmentForm: React.FC = observer(() => {
    const {initiativeInstanceStore, attachmentStore, sitApi} = useSitStores();
    const [isDownloading, setIsDownloading] = React.useState(false);
    const result = attachmentStore.initiativeAttachmentsRM.result;

    useEffect(() => {
        if (!initiativeInstanceStore.creating && (initiativeInstanceStore.instance.id ?? 0) !== 0) {
            attachmentStore.initiativeAttachmentsRM.request({id: initiativeInstanceStore.instance.id!});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initiativeInstanceStore.instance.id]);

    const download = (attachment: {id: number}) => {
        if (isDownloading) return;
        setIsDownloading(true);
        sitApi.downloadInitiativeAttachment(initiativeInstanceStore.instance.id!, attachment.id).then((resp) => {
            const url = URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachmentStore.fileName(attachment as never));
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        }).finally(() => setIsDownloading(false));
    };

    if (result !== undefined && result.length === 0)
        return <div className="sit-muted">No attachments uploaded yet.</div>;

    if (!result || result.length === 0) return null;

    return (
        <div className="sit-table-wrap">
            <table className="sit-table">
                <thead>
                    <tr><th>Name</th><th>Date</th><th className="right"/></tr>
                </thead>
                <tbody>
                    {result.map((attachment, index) => (
                        <tr key={index}>
                            <td><Article fontSize="inherit"/> {attachmentStore.fileName(attachment)}</td>
                            <td>{attachment.created.toLocaleString()}</td>
                            <td className="right">
                                <button type="button" className="iconbtn small" onClick={() => download(attachment)}
                                        aria-label="Download"><Download fontSize="inherit"/></button>
                                <button type="button" className="iconbtn small" disabled={initiativeInstanceStore.disabled}
                                        onClick={() => attachmentStore.delete(attachment.id)}
                                        aria-label="Delete"><Delete fontSize="inherit"/></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
});
